import { render, staticRenderFns } from "./LastChangesModal.vue?vue&type=template&id=6fcfd810"
import script from "./LastChangesModal.vue?vue&type=script&lang=js"
export * from "./LastChangesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports